import script from "./MindmapManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MindmapManage.vue?vue&type=script&lang=ts&setup=true"

import "./MindmapManage.vue?vue&type=style&index=0&id=eda61328&lang=css"

const __exports__ = script;

export default __exports__